import React, { useState } from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";
import ContactStagesWidget from "Pages/Dashboard/dashboard/DashboardV2/Widgets/ContactStagesWidget";
import StatTile from "../visuals/StatTile";

const VISUALIZATIONS = [
  { value: "BAR", label: "Bar", icon: "bar_chart" },
  { value: "LINE", label: "Line", icon: "show_chart" },
  { value: "KPI", label: "Numbers", icon: "format_list_numbered" }
];

const ChartBlock = observer(({ block }) => {
  const [visualization, setVisualization] = useState("BAR");
  const tiles = block.tiles || [];
  const distribution = block.distribution || [];

  if (!tiles.length && !distribution.length) return null;

  // The agent composes which bucket to accent per question, by LABEL. The
  // widget wants the stage CODE, and an emphasis that matches nothing must
  // fall back to the deterministic highlight rather than clearing it.
  const emphasized =
    (block.emphasis &&
      (distribution.find(row => row.stageLabel === block.emphasis) || {}).stage) ||
    (block.highlight ? block.highlight.stage : null);

  return (
    <div className="copilotChart">
      <div className="copilotChart__header">
        <span className="copilotChart__title">{block.title}</span>
        {distribution.length > 0 && (
          <div className="copilotChart__viz" role="group" aria-label="Chart type">
            {VISUALIZATIONS.map(option => (
              <button
                key={option.value}
                type="button"
                className={`copilotChart__vizBtn${
                  visualization === option.value ? " is-active" : ""
                }`}
                aria-pressed={visualization === option.value}
                aria-label={option.label}
                title={option.label}
                onClick={() => setVisualization(option.value)}
              >
                <i className="material-icons-outlined">{option.icon}</i>
              </button>
            ))}
          </div>
        )}
      </div>

      {tiles.length > 0 && (
        // Same StatTile the kpi_row block uses, which is itself the dashboard's
        // CountWidget/RateWidget. Previously this block drew its own little
        // boxed tiles, which read as cramped next to every other visual.
        <div className="copilotChart__tiles">
          {tiles.map(tile => (
            <StatTile
              key={tile.label}
              label={tile.label}
              value={tile.value}
              unit={tile.unit}
              // The spec carries a trend when the tool supports a date range —
              // dropping it here is why the arrows never appeared.
              delta={tile.delta}
              size="sm"
            />
          ))}
        </div>
      )}

      {distribution.length > 0 && (
        <div className="copilotChart__body">
          <ContactStagesWidget
            showAxes
            contactStages={distribution}
            visualization={visualization}
            highlightStage={emphasized}
            // A bar is a question, not a dead end: clicking asks about it.
            onSelect={stage => {
              if (copilotStore.streaming) return;
              const name = stage.stageLabel || stage.stage;
              copilotStore.sendUserMessage(
                `Show me the ${stage.count} contacts with status "${name}" in this sequence`
              );
            }}
          />
        </div>
      )}
    </div>
  );
});

export default ChartBlock;
